import ProjectData from "@/data/ProjectData.ts";

const ludoPolyProject = new ProjectData(
  "project-1",
  "Ludo Poly",
  "img/projects/LudoPoly/ludopolylogo.png",
  `
    <div class="paragraph">
        <div class="wip-badge">🚧 Work in Progress</div>
        <strong>Ludo Poly Pixel</strong> - A fun twist on the classic Ludo board game with pixel art style.
        <br/>Working on this with my friends as a passion project. We're documenting the whole journey with regular devlog updates!
    </div>
    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/LudoPoly/ludopoly1.png" alt="Ludo Poly Gameplay Screenshot" />
    </div>
    <div class="paragraph center">
        <a href="https://tonkin.itch.io/tinytactics" target="_blank"><img src="img/itchiologo.svg" alt="Available on itch.io" class="platform-logo" /></a>
    </div>

    <div class="paragraph">
        <strong>What I'm Working On:</strong>
        <ul>
        <li>📊 <strong>Research:</strong> Looking into what makes digital board games fun and what players actually want from a modern Ludo game</li>
        <li>📋 <strong>Planning:</strong> Using Trello to keep track of features and coordinate with the team - honestly a lifesaver for staying organized</li>
        <li>🎮 <strong>Programming:</strong> Building the core game - board logic, how pieces move, turn system, and figuring out when someone wins</li>
        <li>🌐 <strong>Multiplayer:</strong> Setting up Colyseus so friends can play together online without lag or sync issues</li>
        </ul>
    </div>
    
    <div class="paragraph">
        <div class="notice wip-notice">
        <strong>Where we're at:</strong> Still in active development! 
        Check out our <a href="https://tonkin.itch.io/tinytactics" target="_blank">itch.io page</a> for updates and early builds.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/LudoPoly/ludopoly1.png" alt="ludopoly1" />
        <img class="pc-screenshot" src="img/projects/LudoPoly/ludopoly2.gif" alt="ludopoly2" />
        <img class="pc-screenshot" src="img/projects/LudoPoly/ludopoly3.gif" alt="ludopoly3" />
    </div>
    `,
  "#dbc940ff",
  true
);

export default ludoPolyProject;
